import React, { useEffect, useState } from "react";
import "./settings.scss";
import { Box, Tab, useMediaQuery } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import BasicDetails from "./basicDetails/BasicDetails";
import SearchingTag from "./searchingTag/SearchingTag";
import sidebarActivePage from "../../stores/sidebarActivePage";

const Settings = () => {
  const SidebarActivePage = sidebarActivePage();
  const matches = useMediaQuery("(max-width:600px)");
  const [tabValue, setTabValue] = useState("1");

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "" });
  }, []);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <div className="settings">
      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} variant="scrollable">
            <Tab label={<p>Basic Details</p>} value="1" className="tabTitle" />
            <Tab label={<p>Searching Tags</p>} value="2" className="tabTitle" />
            <Tab label={<p>Item Three</p>} value="3" className="tabTitle" />
          </TabList>
        </Box>
        <TabPanel
          value="1"
          className="tab-panel"
          sx={{ p: matches ? "20px 5px" : 2 }}
        >
          <BasicDetails />
        </TabPanel>
        <TabPanel
          value="2"
          className="tab-panel"
          sx={{ p: matches ? "20px 5px" : 2 }}
        >
          <SearchingTag />
        </TabPanel>
        <TabPanel value="3">Item Three</TabPanel>
      </TabContext>
    </div>
  );
};

export default Settings;
